import { Box, Container, Typography } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { colors } from "../../../../ui/colors";

interface CancelledInvoiceViewProps {
  sellerBusinessName?: string;
  sellerContactEmail?: string;
  sellerContactName?: string;
}

/**
 * Shown to the buyer when they open the invoice payment link and the invoice has been cancelled.
 * No payment options; seller contact info only.
 */
export function CancelledInvoiceView({
  sellerBusinessName,
  sellerContactEmail,
  sellerContactName,
}: CancelledInvoiceViewProps) {
  return (
    <Box sx={{ minHeight: "100vh", py: 4, bgcolor: colors.gray[50], display: "flex", alignItems: "center" }}>
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            bgcolor: "var(--fx-surface-base, #FFFFFF)",
            borderRadius: 2,
            boxShadow: 1,
            p: 4,
            border: `1px solid ${colors.gray[200] ?? "var(--fx-surface-border, #E2E8F0)"}`,
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              bgcolor: colors.gray[200],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <ReceiptIcon sx={{ fontSize: 32, color: colors.gray[600] }} />
          </Box>
          <Typography variant="h6" fontWeight={700} sx={{ color: colors.gray[800], mb: 1 }}>
            This invoice has been cancelled
          </Typography>
          <Typography variant="body2" sx={{ color: colors.gray[600], mb: 2 }}>
            This invoice is no longer available for payment. Please contact{sellerBusinessName ? ` ${sellerBusinessName}` : " the seller"} for an updated invoice.
          </Typography>
          {(sellerContactName || sellerContactEmail) && (
            <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: "divider" }}>
              <Typography variant="caption" sx={{ color: colors.gray[500], display: "block" }}>
                Seller contact
              </Typography>
              {sellerContactName && (
                <Typography variant="body2" fontWeight={600} sx={{ color: colors.gray[700] }}>
                  {sellerContactName}
                </Typography>
              )}
              {sellerContactEmail && (
                <Typography variant="body2" component="a" href={`mailto:${sellerContactEmail}`} sx={{ color: colors.blue[600] }}>
                  {sellerContactEmail}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
}
